import "./PreviewFeed.scss";
import { PropsWithChildren } from "react";

export const PreviewFeed = ({ children }: PropsWithChildren) => {
  return (
    <div className="previewFeed">
      {children}
    </div>
  );
};
